import { useLayoutEffect, useState, UIEvent } from 'react';
import { useBridge } from './bridge';
import { window } from './window';

export function useNativeWebBackNavigation<E extends UIEvent, R>(
  callback?: (event: E) => R,
) {
  const bridge = useBridge();
  const delay = useDelayed();

  return bridge.status === 'webview:missing'
    ? callback
    : (event: E) => {
        bridge.postMessage({
          type: 'navigate:back',
          window: { location: window('location') },
        });

        if (typeof callback === 'function') {
          event?.persist?.();
          delay(() => callback(event));
        }
      };
}

function useDelayed() {
  const [delayed, setDelayed] = useState<() => void>();

  useLayoutEffect(() => delayed?.(), [delayed]);

  return setDelayed;
}
